import PersonIcon from '@mui/icons-material/Person';
import ScienceIcon from '@mui/icons-material/Science';
import HistoryIcon from '@mui/icons-material/History';
import GroupIcon from '@mui/icons-material/Group';
import { useTranslation } from 'react-i18next';

export const useResources = () => {
  const { t } = useTranslation();
  return [
    {
      name: 'admin/studies',
      list: '/studies',
      create: '/studies/create',
      edit: '/studies/edit/:id',
      show: '/studies/show/:id',
      meta: {
        canDelete: true,
        label: 'Études',
        icon: <ScienceIcon />,
      },
    },
    {
      name: 'researchers',
      list: '/researchers',
      create: '/researchers/create',
      edit: '/researchers/edit/:id',
      show: '/researchers/show/:id',
      meta: {
        canDelete: false,
        label: t('menu.users'),
        icon: <PersonIcon />,
      },
    },
    {
      name: 'admin/participants',
      list: '/participants',
      edit: '/participants/edit/:id',
      show: '/participants/show/:id',
      meta: {
        canDelete: false,
        label: t('pages.participants.title'),
        icon: <GroupIcon />,
      },
    },
    {
      name: 'admin/audit-logs',
      list: '/audit-logs',
      meta: {
        canDelete: false,
        label: t('pages.auditLogs.title'),
        icon: <HistoryIcon />,
      },
    },
  ];
};
